import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from "components/Datepicker/Datepicker";

import useAuth from "hooks/useAuth";

import api from "assets/services/api";


function ModalValidateSell(props) {
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const [deliverymans, setDeliveryman] = useState([]);
  const [startDate, setStartDate] = useState(new Date().withoutTime());
  const [deliverymanId, setDeliverymanId] = useState(null);

  const { storageId } = useAuth();

  useEffect(() => {
    if(controlSnack) showNotification("br")
  }, [controlSnack]);

  useEffect(() => {
    loadDeliveryman();
  }, []);

  async function loadDeliveryman() {
    const response = await api.get('/deliveryman/operator/' + storageId);
    setDeliveryman(response.data);
  }

  async function handleValidateSell(e) {
    e.preventDefault();
    try {   
      const response = await api.put('/sell/validated/' + props.props.id, {
        date_of_delivery: startDate,
        id_deliveryman: deliverymanId !== null ? deliverymanId : deliverymans[0].id
      });
      if (response.data.error) {
        return alert(response.data.error);
      }
      if (response.status === 200) {
        setControlSnack(true);
        props.onHide();
        props.loadTotal();
        props.loadSell();
      }
    } catch (err) {
      alert("Você não possui estoque para esta ação");
    }
  }

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Validar venda
          </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleValidateSell}>
        <Modal.Body>
          <h4> Tem certeza que deseja validar essa venda? Se sim, defina a data da entrega e o entregador.</h4>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDeliveryman">
              <Form.Label>Entregador</Form.Label>
              <Form.Control onChange={event => setDeliverymanId(event.target.value)} as="select" defaultValue="Choose...">
                {deliverymans.map(deliveryman => (
                  <option key={String(deliveryman.id)} value={deliveryman.id}>{deliveryman.deliverymanname}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data</Form.Label>
              <div>
                <DatePicker
                  selected={startDate}
                  onChange={date => setStartDate(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation />
              </div>
            </Form.Group>
          </Form.Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Validar
          </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Venda validada com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalValidateSell;